import React from 'react';
import { FluentInputArea } from '../../../../../components/FluentUI/Fluent-InputArea';
import { makeStyles, shorthands } from '@fluentui/react-components';
import PropTypes from 'prop-types';

const useStyles = makeStyles({
    root: {
        display: "flex",
        padding: "7px",
        ...shorthands.border("1px", "solid", "#EEEEEE"),
        resize: "vertical !important",
        fontSize: "12px !important",
        color: "#4E4E4E",
        marginTop: "6px",
        marginBottom: "20px",
    },
});

function ProjectDescription({
    value,
    handleFormChange,
}) {
  const fieldStyle = useStyles();
  return (
    <FluentInputArea
        className="project-description"
        label="Description"
        placeholder="Enter Description"
        defaultValue={value}
        size={"small"}
        required={false}
        onChange={(e) => handleFormChange("Description", e.target.value)}
        componentStyle={fieldStyle.root}
        noKey={true}
    />
  )
}

ProjectDescription.propTypes = {
    value: PropTypes.string,
    handleFormChange: PropTypes.func.isRequired,
}

export default ProjectDescription;